// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import './css/vendor.scss';
import './css/main.scss';

import './config/axios';
import router from './router';

import vSelect from 'vue-select';

import filters from './filters';
import droFilters from './modules/dro/filters';
import Meta from 'vue-meta';
import Touch from 'lib/vue-touch-events';
import App from './App.vue';

import store from './store';
import {sync} from 'vuex-router-sync';
import VueMDCAdapter from 'vue-mdc-adapter';
import VCalendar from 'v-calendar';
import initFilters from './lang/filters';
import {ServerTable, ClientTable, Event} from 'vue-tables-2';
import Validator from './bootstrap/validator'
import VTooltip from 'v-tooltip'

Vue.use(Validator);

Vue.component('v-select', vSelect);

Vue.use(filters);

Vue.use(droFilters);

Vue.use(VueMDCAdapter);

Vue.use(VCalendar);

initFilters(Vue);

Vue.use(Meta);

Vue.use(Touch);
Vue.use(ServerTable);
Vue.use(ClientTable);

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

Vue.config.productionTip = false;

Vue.use(VTooltip)

sync(store, router);


/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.ts